import { useCallback, useEffect } from "react";

import Hotjar from "@hotjar/browser";

import { formatFractionDisplay, useGetAllCarbonProgramOutcomes, useGetFarms, useUserContext } from "utils";

export const AnalyticsUpdater = () => {
  const { user } = useUserContext();
  const { currentFarm } = useGetFarms();

  const { data: programOutcomes } = useGetAllCarbonProgramOutcomes(currentFarm?.id, currentFarm?.carbonProgram);

  const calculateActiveFarmRemovalProgress = useCallback((): number => {
    if (!programOutcomes) return 0;

    const currentYear = new Date().getFullYear();

    const { validPracticesCount, totalPossiblePractices } = Object.values(programOutcomes).reduce(
      (acc, outcome) => {
        if ("fieldOutcomes" in outcome) {
          Object.values(outcome.fieldOutcomes).forEach((practice) => {
            if (practice.isParticipating && practice.years[currentYear]?.validation?.valid) {
              acc.validPracticesCount += 1;
            }
            acc.totalPossiblePractices += 1;
          });
        }
        return acc;
      },
      { validPracticesCount: 0, totalPossiblePractices: 0 }
    );

    const formatedValue = totalPossiblePractices > 0 ? formatFractionDisplay(validPracticesCount / totalPossiblePractices) : 0;
    return formatedValue || 0;
  }, [programOutcomes]);

  // add user attributes to Hotjar
  const addHotjarUserAttributes = useCallback(() => {
    if (Hotjar.isReady() && user) {
      Hotjar.identify(user.id, {
        user_country: user.farm.country,
        user_language: user.language,
        user_has_farm: !!user.farm,
        user_has_fields: user.farm.fields > 0,
        farmer_segmentation: user.farm.isOffsettingFarm ? "offsetting" : "insetting",
        partner_name: user.farm.partner || "",
        has_hectares_in_conversion: user.farm.hectaresInConversion > 0,
        klim_user: user.email.toLocaleLowerCase().includes("klim"),
        data_provision_progress: calculateActiveFarmRemovalProgress(),
      });
    }
  }, [calculateActiveFarmRemovalProgress, user]);

  useEffect(() => {
    addHotjarUserAttributes();
  }, [addHotjarUserAttributes]);

  return null;
};
